import React from "react";
import BarraSupDent from "../../commons/BarraSupDent";
import { Link } from "react-router-dom";
import firebaseManager from "../../model/Firebase/FirebaseManager";
import NavbarDownConsumer from "../../commons/NavbarDownConsumer";
import "./View_profile.css";

class View_profile extends React.Component {
  // fake authentication Promise
  authenticate() {
    return new Promise((resolve) => setTimeout(resolve, 2000)); // 2 seconds
  }

  componentDidMount() {
    this.authenticate().then(() => {
      const ele = document.getElementById("ipl-progress-indicator");
      if (ele) {
        // fade out
        ele.classList.add("available");
        setTimeout(() => {
          // remove from DOM
          ele.outerHTML = "";
        }, 2000);
      }
    });
  }

  constructor(props) {
    super();
    this.state = {
      userData: [],
      image: null,
    };
    this.getDentuser();
  }

  getDentuser() {
    firebaseManager.getInfoForCurrentTechnician(this.getDentIdsCallback);
  }

  getDentIdsCallback = (dentIdData) => {
    this.setState({
      userData: this.state.userData.concat([dentIdData]),
    });
    let userData = document.getElementById("userData");

    if (userData) {
      userData.innerHTML += `
        <div class="text-center pt-2">
        <div class="container mt-3">
        <table class="table table-borderless profile">
        <tbody>
          <tr>
            <td>FULLNAME:</td>
            <td>${dentIdData.name || ""}</td>
          </tr>
          <tr>
            
            <td>EMAIL:</td>
            <td>${dentIdData.email || ""}</td>
           
          </tr>
          <tr>
          
            <td>PHONE NUMBER:</td>
            <td>${dentIdData.phoneNumber || ""}</td>
          </tr>
          <tr>                          
          <td>ADDRESS:</td>
          <td>${dentIdData.address || ""}</td>
          </tr>
          </tbody>
        </table>
        </div>
    </div>`;
    }
    if (dentIdData.phoneNumber === "") {
      document.getElementById("alert").classList.remove("d-none");
      document.getElementById("navbarConsumer").classList.add("d-none");
      document.getElementById("btnBack").classList.add("d-none");
    }
  };

  render() {
    return (
      <React.Fragment>
        <BarraSupDent />
        <div id="alert" className="alert alert-danger d-none" role="alert">
          <p className="text-center">
            Please provide your phone number, just in case the Dent Specialist
            needs to contact you.
          </p>
        </div>
        <div
          className="mt-5 mb-3 d-flex justify-content-center"
          id="userData"
        ></div>
        <div className="mb-5">
          <Link to="/Settings">
            <p className="pSize colorLink text-center mb-5 mt-5">
              Account settings
            </p>
          </Link>
        </div>
        <NavbarDownConsumer />
      </React.Fragment>
    );
  }
}

export default View_profile;
